import { NavLink, useMatch } from "react-router-dom";
import LeaguesIcon from "components/svg/LeaguesIcon";
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { useGetLeagueQuery } from "../api/endpoints/leagueDetail";
import { useGetLeagueRoundQuery } from "../api/endpoints/rounds";
import { leagueIdFromPath } from "../utils/leagueIdFromPath";

export function LeaguesNavSection() {
  const isInLeagues = !!useMatch({ path: "/leagues", end: false });
  const leagueDetailMatch = useMatch("/leagues/:leagueId");
  const roundMatch = useMatch("/leagues/:leagueId/rounds/:roundId");
  // leagueId comes from the detail route OR any deeper league-scoped route
  // (e.g. a round page) so the league link stays visible as the parent crumb.
  const rawLeagueId =
    leagueDetailMatch?.params.leagueId ?? roundMatch?.params.leagueId;
  const leagueId = leagueIdFromPath(rawLeagueId);
  const roundId = roundMatch?.params.roundId;
  const isDashboard = !!useMatch({ path: "/leagues", end: true });

  const { data: leagueData } = useGetLeagueQuery(leagueId ?? "", {
    skip: !leagueId,
  });

  const { data: roundData } = useGetLeagueRoundQuery(
    { leagueId: leagueId ?? "", roundId: roundId ?? "" },
    { skip: !leagueId || !roundId },
  );

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        render={<NavLink to="/leagues" />}
        isActive={isInLeagues}
        tooltip="Leagues"
      >
        <LeaguesIcon class="size-4 shrink-0" />
        <span>Leagues</span>
      </SidebarMenuButton>

      {isInLeagues && (
        <SidebarMenuSub className="animate-in fade-in-0 slide-in-from-top-2 duration-200 motion-reduce:animate-none">
          <SidebarMenuSubItem>
            <SidebarMenuSubButton
              render={<NavLink to="/leagues" />}
              isActive={isDashboard}
              size="sm"
            >
              Dashboard
            </SidebarMenuSubButton>
          </SidebarMenuSubItem>

          {leagueId && (
            <SidebarMenuSubItem>
              <SidebarMenuSubButton
                render={<NavLink to={`/leagues/${leagueId}`} />}
                isActive={!!leagueDetailMatch}
                size="sm"
              >
                <span
                  className="truncate"
                  title={leagueData?.leagueV2Detail?.name ?? undefined}
                >
                  {leagueData?.leagueV2Detail?.name ?? "League"}
                </span>
              </SidebarMenuSubButton>
            </SidebarMenuSubItem>
          )}

          {leagueId && roundId && (
            <SidebarMenuSubItem>
              <SidebarMenuSubButton
                render={
                  <NavLink to={`/leagues/${leagueId}/rounds/${roundId}`} />
                }
                isActive={!!roundMatch}
                size="sm"
              >
                <span
                  className="truncate"
                  title={roundData?.roundName ?? undefined}
                >
                  {roundData?.roundName ?? "Round"}
                </span>
              </SidebarMenuSubButton>
            </SidebarMenuSubItem>
          )}
        </SidebarMenuSub>
      )}
    </SidebarMenuItem>
  );
}
